export default __webpack_public_path__ + "445c8938249a4e8218af5e3cf926f666.svg";